export function defaultValidateHandler(name, value) {
  let newErrors = { ...this.state.errors };

  if (this.state.hasOwnProperty(name)) {
    const error = this.validate({ [name]: value });

    if (!error.hasOwnProperty(name)) {
      delete newErrors[name];
    } else {
      newErrors[name] = error[name];
    }
  } else {
    const props = this.getProperties();
    newErrors = this.validate({ ...props });
  }

  this.setState({ errors: newErrors });

  return !Object.keys(newErrors).length;
}

export function defaultValidateStatus(field) {
  return this.state.errors[field] ? 'error' : null;
}

export function defaultOnChange(event) {
  this.setState({ [event.target.name]: event.target.value });
}

export function defaultOnCheckboxChange(event) {
  const { name } = event.target;
  this.setState({ [name]: !this.state[name] });
}

export function defaultOnBlur(event) {
  this.validateHandler(event.target.name, event.target.value);
}



// WEBPACK FOOTER //
// ./src/utils/form.js